import React, { useState } from "react";
import { motion } from "framer-motion";
import "../../Css/PrinterTile.css";
import ProgressBar from "../Progressbar";




const progress = 13; // dynamicznie podstawiasz ten procent
const status = 2; //statusy to 3 error, 2 - printing, 1 idle, 0 offline
const Tile = ({ tile }) => {
  const [isHovered, setIsHovered] = useState(false);

  let content;
  switch (status) {
    case 1: // idle
      content = (
        <div className="printer-top">
          <div className="tile-dots">
            <button
              className="tile-dots-btn"
              type="button"
              style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
            >
              {dotsSVG()}
            </button>
          </div>
          <div className="printer-bottom" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
            <button className="tile-action tile-action-start" type="button">
              Start Print
            </button>
          </div>
        </div>
      );
      break;
    case 2: // printing
      content = (
        <>
          <div className="printer-top">
            <motion.div className="tile-buttons" variants={buttonsVariants}>
              <div className="tile-hover-item">
                <button className="tile-action tile-action-cancel" type="button">
                  {cancelSVG()}
                </button>
                <span className="tile-action-cancel-text">Cancel</span>
              </div>
              <div className="tile-hover-item">
                <button className="tile-action tile-action-pause" type="button">
                  {pauseSVG()}
                </button>
                <span className="tile-action-pause-text">Pause</span>
              </div>
              <div className="tile-hover-item"></div>
            </motion.div>
            <div className="tile-dots">
              <button
                className="tile-dots-btn"
                type="button"
                style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
              >
                {dotsSVG()}
              </button>
            </div>
          </div>
          <div className="printer-bottom">
            <motion.div className="tile-label-hover" variants={labelVariantsHover}>
              <LabelItemHover value="212°" subvalue="220°" icon={hotendIcon} />
              <LabelItemHover value="31°" subvalue="65°" icon={bedIcon} />
              <LabelItemHover value="200g" subvalue="83%" icon={weightIcon} />
              <LabelItemHover value="00:33" subvalue="10.03" icon={timeIcon} />
            </motion.div>
            <motion.div className="tile-label" variants={labelVariants}>
              <LabelItem value="212°" icon={hotendIcon} />
              <LabelItem value="31°" icon={bedIcon} />
              <LabelItem value="200g" icon={weightIcon} />
              <LabelItem value="00:33h" icon={timeIcon} />
            </motion.div>
            <ProgressBar progress={progress} hovered={isHovered} />
          </div>
        </>
      );
      break;
    // Dodaj kolejne case dla innych statusów (np. error, offline)
    default:
      content = <div>Nieznany status</div>;
  }

  return (
    <motion.div
      className="printer-box"
      initial="rest"
      whileHover="hover"
      animate="rest"
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
    >
      <motion.div className="printer" variants={tileVariants}>
        {content}
      </motion.div>
    </motion.div>
  );
};

export default Tile;

// ---------------------------
// 🧩 Komponent pojedynczego labela z animacją
const LabelItem = ({ value, icon }) => (
  <div className="tile-label-item">
    <span>{value}</span>
    {icon} 
  </div>
);
const LabelItemHover = ({ value, subvalue, icon }) => (
  <div className="tile-label-item-hover">
    <div className="item-icon">{icon}</div>
    <div className="item-value">{value}</div>
    <div className="item-subvalue">{subvalue}</div>
  </div>
);

const cancelSVG = () => (
  <div >
     <svg className="ico" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <line x1="4" y1="4" x2="16" y2="16" stroke="currentColor" strokeWidth="2"/>
                  <line x1="16" y1="4" x2="4" y2="16" stroke="currentColor" strokeWidth="2"/>
     </svg>
  </div>
);
const pauseSVG = () => (
  <div >
      <svg className="ico" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <rect x="5" y="4" width="3" height="12" rx="1" fill="currentColor"/>
                  <rect x="12" y="4" width="3" height="12" rx="1" fill="currentColor"/>
                </svg>
  </div>
);
const dotsSVG = () => (
  <svg className="ico" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <circle cx="5" cy="12" r="2" fill="currentColor"/>
    <circle cx="12" cy="12" r="2" fill="currentColor"/>
    <circle cx="19" cy="12" r="2" fill="currentColor"/>
  </svg>
);
//   rest: {
//     opacity: 1,
//     transition: { duration: 0.3 },
//   },
//   hover: {
//     opacity: 0,
  
//     transition: {
//      duration: 0.3 
//     },
//   },
// };
const labelVariants = {
  rest: { opacity: 1, z: 0, y: 0, transition: { duration: 0.1 } },
  hover: { opacity: 0, z: -1, y: -10, transition: { duration: 0.1 } },
};

const labelVariantsHover = {
  rest: { opacity: 0, y: 30, transition: { duration: 0.3 } },
  // rest: { opacity: 1, y: 40, transition: { duration: 0.3 } },
  hover: { opacity: 1, y: 18, transition: { duration: 0.2 } },
};

const buttonsVariants = {
  rest: { opacity: 0, y: 20, transition: { duration: 0.2 } },
  // rest: { opacity: 1, y: 20, transition: { duration: 0.3 } },
  hover: { opacity: 1, y: 0, transition: { duration: 0.2 } },
};


// const progressVariants = {
//   rest: { height: ".5rem" },
//   hover: {
//     height: "1rem",
//     transition: { duration: 0.2 },
//   },
// };

// const percentVariants = {
//   hidden: { opacity: 0, x: 20 },
//   visible: { opacity: 1, x: 0, transition: { duration: 0.3 } },
//   exit: { opacity: 0, x: 20, transition: { duration: 0.2 } },
// };

const tileVariants = {}; // Pusty – opcjonalnie coś dodaj

// ---------------------------
// 🔧 Ikonki SVG
const hotendIcon = (
  <svg className="ico" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <rect x="7" y="2" width="4" height="6" rx="1" fill="currentColor"/>
    <rect x="8" y="8" width="2" height="3" rx="1" fill="currentColor"/>
    <rect x="7" y="11" width="4" height="2" rx="1" fill="currentColor"/>
    <path d="M9 13v2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

const bedIcon = (
  <svg className="ico" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <rect x="3" y="13" width="12" height="2" rx="1" fill="currentColor"/>
    <rect x="5" y="11" width="8" height="2" rx="1" fill="currentColor"/>
    <rect x="6" y="9" width="6" height="1" rx="0.5" fill="currentColor"/>
  </svg>
);

const weightIcon = (
  <svg className="ico" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <line x1="9" y1="3" x2="9" y2="12" stroke="currentColor" strokeWidth="1.5"/>
    <ellipse cx="9" cy="14" rx="4" ry="2" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    <path d="M5 7 Q9 10 13 7" stroke="currentColor" strokeWidth="1.2" fill="none"/>
    <circle cx="5" cy="7" r="1" stroke="currentColor" strokeWidth="1" fill="none"/>
    <circle cx="13" cy="7" r="1" stroke="currentColor" strokeWidth="1" fill="none"/>
    <path d="M9 3 Q7 5 5 7" stroke="currentColor" strokeWidth="1" fill="none"/>
    <path d="M9 3 Q11 5 13 7" stroke="currentColor" strokeWidth="1" fill="none"/>
  </svg>
);

const timeIcon = (
  <svg className="ico" width="15" height="18" viewBox="0 0 18 18" fill="none">
    <path d="M5 3h8M5 15h8M6 3c0 4 6 4 6 0M6 15c0-4 6-4 6 0" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    <path d="M9 7c-2 1.5-2 2.5 0 4c2-1.5 2-2.5 0-4z" fill="currentColor"/>
  </svg>
);
